export default "__VITE_ASSET__B$sC57zR__"